import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'; // For Bootstrap 4 styles
// import 'datatables.net/js/jquery.dataTables.min.js';          // For DataTables functionality
// import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';  // For Bootstrap integration
import $ from "jquery";
import {
  faHome,
  faPencil,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OffersPage = () => {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(0);

  // Fetch Offers data
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await axios.get("/website/offers");
        setOffers(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching offers:", error);
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  // Initialize DataTables after the component mounts
  // useEffect(() => {
  //   // Initialize DataTable when the table is available
  //   if (window.$) {
  //     window.$('#maindatatable').DataTable();
  //   }
  // }, [offers]); // Reinitialize if offers data changes

  const handleAddOffer = () => {
    navigate("/Website/Offers/add");
  };

  const handleEditOffer = (id) => {
    navigate(`/Website/Offers/edit/${id}`);
  };

  const handleDeleteOffer = async () => {
    try {
      await axios.delete(`/website/offers/delete/${deleteId}`);
      Swal.fire("Success", "Offer deleted successfully", "success");
      setOffers(offers.filter((offer) => offer.id !== deleteId));
      setDeleteId(0);
    } catch (error) {
      Swal.fire("Error", "Failed to delete offer", "error");
    }
  };

  const handleDeleteBox = (id) => {
    setDeleteId(id);
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this offer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteOffer();
      }
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "---";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        {/* Breadcrumb */}
        <div className="row">
          <div className="col-md-6">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/Dashboard">
                  <FontAwesomeIcon icon={faHome} /> Home
                </a>
              </li>
              <li className="breadcrumb-item active">Manage Offers</li>
            </ul>
          </div>
          <div className="col-md-6">
            <button
              className="btn btn-default btn-sm pull-right mb-3"
              onClick={handleAddOffer}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Offer
            </button>
          </div>
        </div>

        {/* Offers Table */}
        <div className="panel panel-default with-rounded-corner with-shadow p-10">
          <table
            className="table table-condensed table-bordered bg-white"
            id="maindatatable"
          >
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>#</th>
                <th>Offer Name</th>
                <th>Offer Code</th>
                <th>Offer Value</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Min - Max Credits</th>
                <th>Min - Max Amount</th>
                <th>Status</th>
                <th style={{ width: "1%" }}>Edit</th>
              </tr>
            </thead>
            <tbody>
              {offers.length ? (
                offers.map((offer, index) => {
                  const symbol = offer.id === 1 ? "₹" : "%";
                  return (
                    <tr key={offer.id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {index + 1}
                      </td>
                      <td>{offer.offername}</td>
                      <td>{offer.offercode}</td>
                      <td>{`${offer.offervalue} ${symbol}`}</td>
                      <td>{formatDate(offer.startdate)}</td>
                      <td>{formatDate(offer.enddate)}</td>
                      <td>{`${offer.mincredits} - ${offer.maxcredits}`}</td>
                      <td>{`${offer.minlimits} - ${offer.maxlimits}`}</td>
                      <td>{offer.activate ? "Active" : "Inactive"}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-xs"
                          onClick={() => handleEditOffer(offer.id)}
                        >
                          <FontAwesomeIcon icon={faPencil} />{" "}
                        </button>
                        <button
                          className="btn btn-danger btn-xs"
                          onClick={() => handleDeleteBox(offer.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />{" "}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    No Offers Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default OffersPage;
